export default "__VITE_ASSET__9sOZIfLf__"